/*******************************************************************************
 * subscriptions.js - Subscription and Trial Period Handling
 * 
 * Handles subscription dialogs, trial period prompts, and window load events
 ******************************************************************************/

import { ELEMENT_IDS, STORAGE_KEYS, API_ENDPOINTS } from './constants.js';
import { getElement, parseBool } from './utils.js';

/**
 * Subscribe function - creates subscription button if in trial period
 * Reads from global: expireOrganization, isTrialPeriodShow, countryCode
 */
export function subscribe() {
    if (typeof expireOrganization === 'undefined' || expireOrganization.length === 0) {
        return;
    }
    
    var subscriptionID;
    var content = expireOrganization;
    var dataArray = content.split(",");

    dataArray.forEach(function(item) {
        var splitCode = item.split(":");
        subscriptionID = splitCode[2];
    });
    
    if (typeof isTrialPeriodShow !== 'undefined' && isTrialPeriodShow === true) {
        var actionURL = "/create-checkout-session/" + subscriptionID + "/" + countryCode;

        var subsBtn = "<div class='col-12'><form action='" + actionURL + "' method='POST'><div class='custom-tooltip'> <button type='submit' id='checkout-button-stripe'  class='e-btn e-primary' style='margin-left: -5px;margin-bottom: 10px;background: #ffff !important;color: #fb0a13 !important;cursor:pointer;margin-top: 10px;padding: 6px;'>Subscribe <span class='vertical-line-introjs' style='border-left: 1px solid #fb0a13;'></span><span class='e-icons e-play' style='font-size: 15px;margin-top:-2px;vertical-align: middle;' ><div class='tooltip' role='tooltip'>Organisation is in free trial. Subscribe to BatchPay Monthly</div> </div></button></form></div>";

        var subscribeEl = document.getElementById("subscribexero");
        if (subscribeEl) {
            subscribeEl.innerHTML = subsBtn;
        }
    }
}

/**
 * Initialize window load handler for subscription dialogs
 * This sets up all the subscription-related dialog logic
 */
export function initWindowLoadHandler() {
    window.addEventListener('load', function() {
        console.log('window load OK');
        
        var spinnerEl = document.getElementById("spinnerSubscription");
        if (spinnerEl) {
            spinnerEl.style.visibility = "hidden";
        }

        if (typeof expireOrganization === 'undefined' || expireOrganization.length === 0) {
            return;
        }

        setTimeout(function() {
            var dialogExpireOrgDialogEl = document.getElementById("promptExpireDialog");
            var promptrActivateSubscriptionDialogEl = document.getElementById("promptrActivateSubscriptionDialog");
            var promptWelcomeSubscriptionDialogEl = document.getElementById("promptWelcomeSubscriptionDialog");
            
            if (!dialogExpireOrgDialogEl || !promptrActivateSubscriptionDialogEl || !promptWelcomeSubscriptionDialogEl) {
                console.log('Subscription dialogs not found');
                return;
            }
            
            var dialogExpireOrgDialog = dialogExpireOrgDialogEl.ej2_instances ? dialogExpireOrgDialogEl.ej2_instances[0] : null;
            var promptrActivateSubscriptionDialog = promptrActivateSubscriptionDialogEl.ej2_instances ? promptrActivateSubscriptionDialogEl.ej2_instances[0] : null;
            var dialogWelcomeSubscriptionDialog = promptWelcomeSubscriptionDialogEl.ej2_instances ? promptWelcomeSubscriptionDialogEl.ej2_instances[0] : null;
            
            if (!dialogExpireOrgDialog || !promptrActivateSubscriptionDialog || !dialogWelcomeSubscriptionDialog) {
                console.log('Subscription dialog instances not ready');
                return;
            }

            // Style the dialogs
            promptrActivateSubscriptionDialogEl.style.maxHeight = "";
            promptrActivateSubscriptionDialogEl.style.background = "#2fa2db";
            promptrActivateSubscriptionDialogEl.style.borderTopLeftRadius = "10px";
            promptrActivateSubscriptionDialogEl.style.borderTopRightRadius = "10px";
            promptrActivateSubscriptionDialogEl.style.borderBottomLeftRadius = "10px";
            promptrActivateSubscriptionDialogEl.style.borderBottomRightRadius = "10px";

            promptWelcomeSubscriptionDialogEl.style.maxHeight = "";
            promptWelcomeSubscriptionDialogEl.style.borderTopLeftRadius = "10px";
            promptWelcomeSubscriptionDialogEl.style.borderTopRightRadius = "10px";
            promptWelcomeSubscriptionDialogEl.style.borderBottomLeftRadius = "10px";
            promptWelcomeSubscriptionDialogEl.style.borderBottomRightRadius = "10px";

            var content = expireOrganization;
            var dataArray = content.split(",");
            var orgs = "";
            var isTrialPeriod = false;
            var isFirstTimeLoging = false;
            var isTrialPeriodStarted = false;
            var isDateEnd = false;
            var subscriptionID = "";
            var orgName = "";

            dataArray.forEach(function(item) {
                var splitCode = item.split(":");
                var name = splitCode[0];
                orgName = splitCode[0];
                var shortCode = splitCode[1];
                subscriptionID = splitCode[2];
                isTrialPeriod = parseBool(splitCode[3].toLowerCase());
                window.isTrialPeriodShow = parseBool(splitCode[3].toLowerCase());
                var remainingTrialPeriodDays = splitCode[4];
                isFirstTimeLoging = parseBool(splitCode[5]);
                isTrialPeriodStarted = parseBool(splitCode[6].toLowerCase());
                isDateEnd = parseBool(splitCode[7].toLowerCase());
                var link = "https://apps.xero.com/" + shortCode + "/subscribe/" + appId;
                
                var feedbackDesc1 = document.getElementById("feedbackDesc1");
                if (feedbackDesc1) {
                    feedbackDesc1.style.visibility = "hidden";
                }
                
                subscribe();
                
                if (isFirstTimeLoging === true) {
                    localStorage.removeItem(STORAGE_KEYS.SELECTED_DATA);
                    localStorage.removeItem(STORAGE_KEYS.SELECTED_DATA_FOR_REMITTANCE);
                }
                
                if (isTrialPeriod === true && isFirstTimeLoging === true) {
                    if (isTrialPeriodStarted === false) {
                        // Build only the "Let's get started" button (Quick Question textarea exists in template)
                        orgs = "<div class='col-12 letstart-btn'>";
                        orgs += "<button type='submit' id='checkout-button-stripe' class='e-btn e-primary btn-activate' style='color: #44C7F4; font-family:Open Sans, sans-serif !important;font-weight: bolder;-webkit-text-stroke: 0.8px #44C7F4;letter-spacing: 2px;text-transform: none;' onclick='feedbackOnBatchPayClick()'>Let's get started</button>";
                        orgs += "</div>";
                        
                        var message = "<div class='row'><div class='col-12' style='text-align: center;padding-top: 20px;'><br></div></div>";
                        message += "<div class='row'><div class='col-12' style='text-align: center;'><br><br></div></div>" + orgs;
                        
                        var promptActivateEl = document.getElementById("promptActivateSubscription");
                        if (promptActivateEl) {
                            promptActivateEl.innerHTML = message;
                        }

                        var dlgContent = document.getElementById("promptrActivateSubscriptionDialog_dialog-content");
                        if (dlgContent) {
                            dlgContent.classList.add("dlg-content-template");
                        }
                        promptrActivateSubscriptionDialog.show();

                        var btnOKWelcome = document.getElementById("btnOKWelcomeSubscription");
                        if (btnOKWelcome) {
                            btnOKWelcome.onclick = function() {
                                promptrActivateSubscriptionDialog.hide();

                                var ajax = new ej.base.Ajax({
                                    url: API_ENDPOINTS.CONTINUE_TRIAL,
                                    type: 'POST',
                                    contentType: 'application/json',
                                    accept: 'application/json'
                                });
                                ajax.send();
                                ajax.onSuccess = function(data) {
                                    var obj = JSON.parse(data);
                                    if (obj.isError && typeof operations !== 'undefined') {
                                        operations.errorHandling(obj);
                                        return;
                                    }
                                };

                                var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                var filteredSelection = existingSelection.filter(function(item) {
                                    return item.orgId !== undefined && item.orgId !== subscriptionID;
                                });
                                localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                // Page no longer refreshes - user stays on the current page
                            };
                        }
                    } else {
                        var actionURL = "/create-checkout-session/" + subscriptionID + "/" + countryCode;
                        
                        // Build the days left circle and Subscribe button HTML
                        var welcomeOrgs = "<div class='row' style='padding-top: 20px;'>";
                        welcomeOrgs += "<div class='remaining-days-container'>";
                        welcomeOrgs += "<div style='text-align: center; font-size: 40px; margin-top: 5px;color: #44c7f5;'>" + remainingTrialPeriodDays + "</div>";
                        welcomeOrgs += "<div style='text-align: center; color: #4f6675;font-size: 15px;'><p>days left.</p><br></div>";
                        welcomeOrgs += "</div>";
                        welcomeOrgs += "</div>";
                        welcomeOrgs += "<div class='row'>";
                        welcomeOrgs += "<div class='col-12' style='margin-bottom: 8px;bottom: 0;width:100px;z-index: 99999;position: absolute;margin-left: 5px;'><form action='" + actionURL + "' method='POST'> <button type='submit' id='checkout-button-stripe' class='e-btn e-primary' style='margin-left: -5px;margin-bottom: 10px;'>Subscribe</button></form></div>";
                        welcomeOrgs += "</div>";
                        
                        var dlgHeader = document.getElementById("promptWelcomeSubscriptionDialog_dialog-header");
                        var dlgContent = document.getElementById("promptWelcomeSubscriptionDialog_dialog-content");
                        if (dlgHeader) dlgHeader.classList.add("prompt-dlg-header-template");
                        if (dlgContent) dlgContent.classList.add("dlg-content-template");
                        dialogWelcomeSubscriptionDialog.show();

                        var message = welcomeOrgs + "<div class='row'><div class='col-12' style='text-align: center;'>The organisation is currently on a complimentary trial.<br></div></div>";
                        message += "<div class='row'><div class='col-12' style='text-align: center;'>Click <b>Subscribe</b> to upgrade your account.<br><br></div></div>";
                        
                        var promptWelcomeEl = document.getElementById("promptWelcomeSubscription");
                        if (promptWelcomeEl) {
                            promptWelcomeEl.innerHTML = message;
                        }

                        dlgHeader = document.getElementById("promptWelcomeSubscriptionDialog_dialog-header");
                        if (dlgHeader) dlgHeader.classList.add("prompt-dlg-header-template");
                        dialogWelcomeSubscriptionDialog.show();

                        var btnOKWelcome = document.getElementById("btnOKWelcomeSubscription");
                        if (btnOKWelcome) {
                            btnOKWelcome.onclick = function() {
                                var ajax = new ej.base.Ajax({
                                    url: API_ENDPOINTS.CONTINUE_TRIAL,
                                    type: 'POST',
                                    contentType: 'application/json',
                                    accept: 'application/json'
                                });
                                ajax.send();
                                ajax.onSuccess = function(data) {
                                    var obj = JSON.parse(data);
                                    if (obj.isError && typeof operations !== 'undefined') {
                                        operations.errorHandling(obj);
                                        return;
                                    }
                                };

                                var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                var filteredSelection = existingSelection.filter(function(item) {
                                    return item.orgId !== undefined && item.orgId !== subscriptionID;
                                });
                                localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                dialogWelcomeSubscriptionDialog.hide();
                                // Page no longer refreshes - user stays on the current page
                            };
                        }
                    }
                } else if (isTrialPeriod === false && isDateEnd === true) {
                    var actionURL = "/create-checkout-session/" + subscriptionID + "/" + countryCode;
                    orgs += "<div class='row'>";
                    orgs += "<div class='col-12' style='text-align: center;'>&nbsp;&nbsp;&nbsp;&nbsp <p>" + name + "</p><br></div>";
                    orgs += "</div>";
                    orgs += "<div class='row'>";
                    orgs += "<div class='col-12' style=' z-index: 999999;margin-left: 10px;text-align: center;right: 0;position: absolute;margin-right: -40%;margin-top: 40px;'><form action='" + actionURL + "' method='POST'> <button type='submit' id='checkout-button-stripe' class='e-btn e-primary'>Subscribe</button></form></div>";
                    orgs += "</div>";
                    
                    var message = "<div class='row'><div class='col-12' style='text-align: center;'>The organisation's subscription have expired.<br></div></div>";
                    message += "<div class='row'><div class='col-12' style='text-align: center;'>To regain access, please click 'Subscribe' and renew your subscription.<br><br></div></div>" + orgs;
                    
                    var prompt2El = document.getElementById("prompt2");
                    if (prompt2El) {
                        prompt2El.innerHTML = message;
                    }

                    var dlgHeader = document.getElementById("promptExpireDialog_dialog-header");
                    if (dlgHeader) dlgHeader.classList.add("prompt-dlg-header-template");
                    dialogExpireOrgDialog.show();

                    var btnOK = document.getElementById("btnOK");
                    if (btnOK) {
                        btnOK.onclick = function() {
                            dialogExpireOrgDialog.hide();
                            window.location = "/Authorization/Disconnect";
                        };
                    }
                } else if (isFirstTimeLoging === true) {
                    localStorage.removeItem(STORAGE_KEYS.SELECTED_DATA);
                    localStorage.removeItem(STORAGE_KEYS.SELECTED_DATA_FOR_REMITTANCE);
                }
            });
        }, 5000);
    });
}

export default { subscribe, initWindowLoadHandler };
